import React from "react";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon, } from "@mui/icons-material";
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";
import moment from "moment";
import { dateMonthYearDateFormat } from "../../../../constants";
import { trackActivity } from "../../../../utils/mixpanel";
import { PermissionWrapper } from "../../../../wrappers";

const HolidayListing = ({ item, onEditFn, ondeleteCalenderFn }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Exceptional Working Days Listing`, page_type: page_type, })
    }
    return (
        <TableRow>
            <TableCell><div style={{ width: item?.name?.length > 45 ? "200px" : ''}}><LessMoreComp name={item?.name || "--"} lessMr='name' /></div></TableCell>
            <TableCell>{item?.date ? moment(item.date).format(dateMonthYearDateFormat) : '--'}</TableCell>
            <TableCell sx={{maxWidth: '200px'}}><LessMoreComp name={item?.notes} lessMr="notes" /></TableCell>
            <TableCell sx={{ textAlign: "right" }}>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calender", operationType: ['C'] }}>
                    <Tooltip title="Edit" arrow> <EditIcon onClick={() => { onEditFn(); handleItemClicked('EditIcon') }} fontSize="small" color="primary" sx={{ cursor: "pointer" }} /> </Tooltip>
                </PermissionWrapper>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "calender", operationType: ['D'] }}>
                    <Tooltip title="Delete" arrow> <DeleteIcon onClick={() => { ondeleteCalenderFn(); handleItemClicked('DeleteIcon') }} fontSize="small" color="error" sx={{ cursor: "pointer" }} /> </Tooltip>
                </PermissionWrapper>
            </TableCell>
        </TableRow>
    );
};

export default HolidayListing;
